import React, {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaOrderLaundryReceptionTypeClothe} from '../../../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {AppTypeClothe} from '../../../../../../model'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../../../components/UI/Select'
import {
  InputText,
  InputNumberDecimal,
  InputTextArea,
} from '../../../../../../../../components/UI/Input'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  idPermission?: ''
  detailpermission?: any
}

const ModalClothe: FC<Props> = ({show, setShow, idPermission, detailpermission}) => {
  const [typeFurniture, setTypeFurniture] = useState<AppTypeClothe[] | any>([])
  const [typeObservations, setTypeObservations] = useState<AppTypeClothe[] | any>([])

  const methods = useForm<AppTypeClothe>({
    resolver: yupResolver(schemaOrderLaundryReceptionTypeClothe),
  })
  const {
    control,
    setValue,
    register,
    formState: {errors},
  } = methods

  const getTypeObservationsList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoObservacionLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
      }))
      setTypeObservations(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeFurnitureList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRopa',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  useEffect(() => {
    if (idPermission) {
      setValue('tipoRopa', detailpermission?.tipoRopa.trim())
      setValue('cantidad', detailpermission?.cantidad)
      setValue('peso', detailpermission?.peso)
      setValue('observacionColor', detailpermission?.observacionColor)
      setValue('tipoObservacion', detailpermission?.tipoObservacion)
      setValue('estado', detailpermission?.estado)
    }
  }, [idPermission])

  useEffect(() => {
    getTypeFurnitureList()
    getTypeObservationsList()
  }, [])

  const handleClose = () => {
    setShow(false)
    setValue('tipoRopa', '')
    setValue('cantidad', '')
    setValue('peso', '')
    setValue('observacionColor', '')
    setValue('estado', '')
    setValue('tipoObservacion', '')
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Detalle de Ropa</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='row'>
            <div className='mb-2 col-6'>
              <label className='required'>Tipo de ropa</label>
              <Select
                control={control}
                name='tipoRopa'
                data={typeFurniture}
                errors={errors}
                disabled={true}
              />
            </div>
            <div className='col-sm-12 col-lg-6'>
              <label className='required'>Cantidad:</label>
              <InputNumberDecimal
                name='cantidad'
                textPlaceholder='Escribe la cantidad'
                register={register}
                errors={errors}
                disabled={true}
              />
            </div>
            <div className='col-sm-12 col-lg-6'>
              <label className='required'>Peso:</label>
              <InputText
                name='peso'
                textPlaceholder='Escribe la cantidad'
                register={register}
                errors={errors}
                disabled={true}
              />
            </div>
            <div className='mb-2 col-6'>
              <label>Tipo de Observación</label>
              <Select
                control={control}
                name='tipoObservacion'
                data={typeObservations}
                errors={errors}
                disabled={true}
              />
            </div>
            <div className='col-sm-12 col-lg-12'>
              <label>Detalle de Observación:</label>
              <InputTextArea
                name='observacionColor'
                textPlaceholder='Escribe la observación'
                register={register}
                errors={errors}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {ModalClothe}
